import { alert } from "@components/common/Alert";

import { SCRIBENOTE_FLASK } from "../constants";

export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");

  if (newWindow) {
    newWindow.opener = null;
    newWindow.focus();
  }
};

export const truncate = (str, n) => {
  return str?.length > n ? str.substr(0, n - 1) + "..." : str;
};

export const evictNoteCache = (cache) => {
  cache.evict({
    id: "ROOT_QUERY",
    fieldName: "inboxTabCount",
  });
  cache.evict({
    id: "ROOT_QUERY",
    fieldName: "teamUserNoteCounts",
  });
  cache.evict({ id: "ROOT_QUERY", fieldName: "inboxNotes" });
};

export const toTitleCase = (str) => {
  if (!str) {
    return "";
  }
  return str
    .replaceAll("-", " ")
    .replaceAll("_", " ")
    .replace(
      /\w\S*/g,
      (text) =>
        text.charAt(0).toUpperCase() +
        text.substring(1).toLowerCase(),
    );
};

/**
 * Normalizes a template title for use in data-testid attributes by replacing spaces with dashes and converting to lowercase.
 * @param {string} title - The title to normalize.
 * @returns {string} The normalized title.
 */
export const normalizeTemplateTitle = (title) => {
  return title.replace(/ /g, "-").toLowerCase();
};

/**
 * A temporary measure for determining where to send requests app wide
 * based on how a feature flag (use-porter-migration-flag) sets the
 * SCRIBENOTE_API_HOST localstorage item
 *
 *
 * @returns {string} The URL of the Flask server to use
 */
export const getTempScribenoteFlask = () => {
  // const flask_host =
  //   localStorage.getItem("SCRIBENOTE_API_HOST") || SCRIBENOTE_FLASK;

  // return flask_host;
  // Not used for now
  return SCRIBENOTE_FLASK;
};

export const isMCloudIFrame = () => {
  return (
    window.location.search.includes("embedded") ||
    window.location.search.includes("mcloud_embedded")
  );
};
export const isMCloudEmbedded = () => {
  return !!localStorage.getItem("mcloud_embedded");
};
export const setMCloudEmbedded = () => {
  localStorage.setItem("mcloud_embedded", true);
};

/**
 * Replaces non-breaking spaces (literal \u00A0, &nbsp;, &#160;) with regular
 * spaces and trims the result. Returns "" for nullish input.
 */
export const stripNbsp = (text) =>
  (text || "").replace(/\u00A0|&nbsp;|&#160;/g, " ").trim();

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(stripNbsp(text));
    alert("success", "Copied to clipboard!");
    return true;
  } catch {
    alert(
      "error",
      "Unable to copy to clipboard. Please copy manually.",
    );
    return false;
  }
};

/**
 * Returns whether the user was marked as a DVM either on their account, or on any team they are a part of.
 */
function isUserDVM(user, teams) {
  if (!user) return false;

  // Users tend to be marked as DVMs by default on their user object, even though they aren't (DVM is the default)
  // Only trust the role on their user if they're not a teams mode user.
  if (teams?.length === 0) {
    if (user.roleId === 1) return true;
    if (user.role?.id === "1") return true;
  }

  for (const team of teams || []) {
    const userTeam = team.userTeams?.find(
      (userTeam) => userTeam?.user?.uuid === user.uuid,
    );
    if (userTeam?.roleId === 1) return true;
    if (userTeam?.role?.id === "1") return true;
  }

  return false;
}

/**
 * Returns the user's first name, along with the "Dr." prefix if they are are DVM.
 */
export const getUserDisplayName = (
  user,
  teams,
  { includeLastName } = {},
) => {
  const nameWithoutPrefix = (
    includeLastName
      ? `${user?.firstName || ""} ${user?.lastName || ""}`
      : user?.firstName || ""
  ).trim();

  if (!nameWithoutPrefix) return "";

  // If the user already has "Dr. " in their first name, don't add the prefix
  if (/^Dr.? /i.test(nameWithoutPrefix)) return nameWithoutPrefix;
  return (isUserDVM(user, teams) ? "Dr. " : "") + nameWithoutPrefix;
};
